import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "@env/environment";
import {Rilevatore} from "../../_models/domain/rilevatore";


@Injectable({
    providedIn: 'root'
})

export class RilevatoreService{
    constructor(private httpClient : HttpClient) {}

    public getRilevatori(): Observable<Rilevatore[]>{
        return this.httpClient.get<Rilevatore[]>(`${environment.urlApi}/private/getAllRilevatore`);
    }
}